import { render } from "./SearchesInApp.vue?vue&type=template&id=80ce1f2e&scoped=true"
import script from "./SearchesInApp.vue?vue&type=script&lang=js"
export * from "./SearchesInApp.vue?vue&type=script&lang=js"

import "./SearchesInApp.vue?vue&type=style&index=0&id=80ce1f2e&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ce1f2e"]])

export default __exports__